const taskFormEndpoints = {
  FORMS: 'loopay-form-management/forms',
} as const;

export default taskFormEndpoints;
